<script>
import styleHOCFactory from './utils';
export default styleHOCFactory('icon-glow');
</script>

<style module>
@import 'styles/variables.css';

._icon-glow-style {
  &:hover {
    filter:url(#svg-gaussian-blur);
    fill: white;
  }
}
</style>
